// import React from 'react';
// import OurStoryAndServices from '../../components/homeComponent/OurStoryAndServices';
// import HomeImageForm from '../../components/homeComponent/HomeImageForm';
// import OurBlogs from '../../components/homeComponent/OurBlogs';
// import HomeCarousel from '../../components/homeComponent/HomeCarousel';
// import OurServices from '../../components/homeComponent/OurServices';

// const Home = () => (
//     <div className='bg-[#fefefe] w-full overflow-x-hidden'>
//         <HomeCarousel />
//         <OurStoryAndServices />
//         <OurServices/>
//         <HomeImageForm />
//         <OurBlogs />
//     </div>
// );

// export default Home;


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from '../../components/common/SEO';
import OurStoryAndServices from '../../components/homeComponent/OurStoryAndServices';
import HomeImageForm from '../../components/homeComponent/HomeImageForm';
import OurBlogs from '../../components/homeComponent/OurBlogs';
import HomeCarousel from '../../components/homeComponent/HomeCarousel';
import OurServices from '../../components/homeComponent/OurServices';

const Home = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/home/get-sections`);
        const data = res.data?.data?.[0];
        setHomeData(data);
      } catch (error) {
        console.error("Error fetching home data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchHomeData();
  }, []);

  // Helper function to strip HTML tags
  const stripHtml = (html) => {
    if (!html) return '';
    const text = html.replace(/<[^>]*>/g, ' ');
    return text.replace(/\s+/g, ' ').trim();
  };

  // Get SEO data from homeData or use defaults
  const getSeoData = () => {
    if (!homeData) {
      return {
        title: "BBSR Services - Professional Business Solutions in India",
        description: "BBSR Services provides expert business solutions including company registration, GST filing, ITR filing, and more. Trusted by 500+ clients.",
        keywords: "business services, company registration, GST, ITR filing, BBSR Services",
        image: "https://www.bbsrservices.co.in/logo.png",
        canonical: "https://www.bbsrservices.co.in/"
      };
    }

    // Use meta fields from database if available
    return {
      title: homeData.metaTitle || `${homeData.heading} | BBSR Services`,
      description: homeData.metaDescription || (homeData.description && homeData.description.length > 0 
        ? stripHtml(homeData.description[0]).substring(0, 160) 
        : "BBSR Services - Professional Business Solutions in India"),
      keywords: homeData.metaKeywords || `${homeData.heading}, BBSR Services, business solutions, company registration, GST, ITR filing`,
      image: homeData.images?.[0] || "https://www.bbsrservices.co.in/logo.png",
      canonical: homeData.canonicalUrl || "https://www.bbsrservices.co.in/"
    };
  };

  const seoData = getSeoData();

  return (
    <>
      {/* SEO Meta Tags for Home Page */}
      <SEO 
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        image={seoData.image}
        type="website"
      />

      <div className='bg-[#fefefe] w-full overflow-x-hidden'>
        <HomeCarousel />
        <OurStoryAndServices />
        <OurServices/>
        <HomeImageForm />
        <OurBlogs />
      </div>
    </>
  );
};

export default Home;